import { Icon, Link } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

export const SpanishDPRCheckmarkFileCard = ({
  state,
}: {
  state: 'ongoing' | 'done' | 'not-applicable';
}) => {
  const { t } = useTranslation('global');

  const isDone = state === 'done';
  const iconName = isDone ? 'shield-star' : 'clock-filled';

  return (
    <div className="flex items-center gap-4 px-16 py-8 text-content-secondary-bg-secondary body-s">
      <Icon name={iconName} size="s" />
      <span>
        {state === 'ongoing'
          ? t('payables.spanishDPR.ongoingTitle')
          : t('payables.spanishDPR.doneTitle')}
      </span>
      <span className="text-content-disabled">|</span>
      <Link
        href={t('payables.spanishDPR.readMoreLink')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('payables.spanishDPR.readMoreCta')}
      </Link>
    </div>
  );
};
